// extracted by mini-css-extract-plugin
module.exports = {"content":"StatusBadge_content__1jtc9"};